<template>
  <RevButtonCard class="w-full sm:w-auto" :to="product.link">
    <div
      class="flex flex-col items-center justify-center space-y-12 px-16 py-12"
    >
      <img
        :alt="product.name"
        class="rounded h-80 w-80 object-cover"
        :src="product.image"
      />
      <div class="flex flex-col items-center space-y-4 text-center">
        <span class="text-body-1">{{ product.name }}</span>
        <span
          v-if="product.details?.sub_title_elements"
          class="text-static-default-low text-caption"
        >
          {{ product.details.sub_title_elements }}
        </span>
        <span v-if="product.details?.price" class="text-body-1-bold">
          <!-- FIXME Handle currency -->
          ${{ product.details.price }}
        </span>
      </div>
    </div>
  </RevButtonCard>
</template>

<script lang="ts" setup>
import { RevButtonCard } from '@ds/components/ButtonCard'

import type { ProductRecommendation } from '~/api/shopping-assistant/types'

defineProps<{
  product: ProductRecommendation
}>()
</script>
